import React from 'react';

import { useFeedback } from 'src/hooks/use-feedback';
import { StyledFeedbackButton } from './styles';

const FeedbackButton: React.FC = ({ children }) => {
  const { loadState, loadFeedback } = useFeedback();
  const isLoading = loadState === 'loading';

  return (
    <StyledFeedbackButton
      onClick={loadFeedback}
      disabled={isLoading}
      loading={isLoading}
    >
      {children}
    </StyledFeedbackButton>
  );
};

export default FeedbackButton;
